export default {
}



// WEBPACK FOOTER //
// ./src/app/tenant/accountability/index/resources/computed.js